import { Button, Divider, Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import KenSelectWrap from '../../../../global_components/KenSelect';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import {
  CreateRetestExam,
  getExamModuleListData,
} from '../../../../Utils/apiServices';
import { useEffect } from 'react';
import KenButton from '../../../../global_components/KenButton';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RetestExam = ({ retestExamDialog, setRetestExamDialog }) => {
  // Options

  const [termOptions, setTermOptions] = useState([]);
  const [CourseOptions, setCourseOptions] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);
  const [examCycleOptions, setexamCycleOptions] = useState([]);
  const [examTypeOptions, setexamTypeOptions] = useState([
    {
      label: 'ReTest',
      value: 'ReTest',
    },
  ]);
  const [examModeOptions, setExamModeOptions] = useState([
    {
      label: 'online',
      value: 'online',
    },
    {
      label: 'offline',
      value: 'offline',
    },
  ]);

  const [durationOptions, setDurationOptions] = useState([
    {
      label: '30',
      value: '30',
    },
    {
      label: '60',
      value: '60',
    },
    {
      label: '90',
      value: '90',
    },
    {
      label: '120',
      value: '120',
    },
    {
      label: '150',
      value: '150',
    },
    {
      label: '180',
      value: 180,
    },
    {
      label: '210',
      value: '210',
    },
    {
      label: '240',
      value: '240',
    },
    {
      label: '270',
      value: '270',
    },
    {
      label: '300',
      value: '300',
    },
  ]);

  // FIlter States
  const [filterIData, setFilterIData] = useState();
  const [selectedTerm, setselectedTerm] = useState('');
  const [selectedCourse, setselectedCourse] = useState([]);
  const [selectedBatch, setselectedBatch] = useState([]);
  const [selectedexamCycle, setselectedexamCycle] = useState([]);
  const [selectedexamType, setSelectedexamType] = useState([]);
  const [selectExamMode, setSelectExamMode] = useState([]);
  const [selectDuration, setSelectDuration] = useState([]);
  const [startTime, setStartTime] = useState('');
  const [examDate, setExamDate] = useState('');

  const handleTermChange = (e) => {
    setselectedTerm(e.target.value);
  };

  const handleCourseChange = (e) => {
    setselectedCourse(e.target.value);
  };

  const handleBatchChange = (e) => {
    setselectedBatch(e.target.value);
  };

  const handleExamCycleChange = (e) => {
    setselectedexamCycle(e.target.value);
  };

  const handleExamTypeChange = (e) => {
    setSelectedexamType(e.target.value);
  };

  const handleExamModeChange = (e) => {
    setSelectExamMode(e.target.value);
  };
  const handleDurationChange = (e) => {
    setSelectDuration(e.target.value);
  };

  const manageExamTime = (e, row) => {
    setStartTime(e.target.value);
  };

  const manageExamDate = (e, row) => {
    setExamDate(e.target.value);
  };

  useEffect(() => {
    getExamModuleListData().then((res) => {
      setFilterIData(res);
    });
  }, []);

  console.log('startTimestartTimestartTime', startTime, examDate);

  useEffect(() => {
    let TermListData = filterIData?.TermList.map((item) => {
      return {
        label: item.TermName,
        value: item.TermId ? item.TermId : item.TermName,
      };
    });
    setTermOptions(TermListData);

    // For Course
    let CourseListData = filterIData?.CourseList.filter((item) => {
      return selectedTerm == item.TermId && item.TermId && item.CourseId;
    }).map((item) => {
      return {
        label: item.CourseName,
        value: item.CourseId ? item.CourseId : item.CourseName,
      };
    });

    setCourseOptions(CourseListData);

    //For Campus
    let CampusListData = filterIData?.campus.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    // setselectCampusData(CampusListData);

    let BatchListData = filterIData?.batchList
      .filter((item) => {
        return item != null;
      })
      .map((item) => {
        return {
          label: item,
          value: item,
        };
      });
    setBatchOptions(BatchListData);

    let ExamCycleListData = filterIData?.ExamMonthList.filter((item) => {
      return item != null;
    }).map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setexamCycleOptions(ExamCycleListData);
  }, [filterIData, selectedTerm]);

  const createExam = () => {
    const payload = [
      {
        studentFacultyRatio: '50:30',
        startTimeOfExam: startTime,
        examType: selectedexamType,
        examTimeZone: 'Asia/Kolkata',
        examCycle: selectedexamCycle,
        duration: selectDuration,
        dateOfExam: examDate,
        batch: selectedBatch,
        course: selectedCourse,
        term: selectedTerm,
      },
    ];

    CreateRetestExam(payload)
      .then((res) => {
        console.log('res', res);
        setRetestExamDialog(false);
        toast.success('Retest Exam Created Successfully', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const closeBtn = () => {
    setRetestExamDialog(false);
  };
  console.log('selectedTermselectedTermselectedTerm', selectedTerm);

  return (
    <div>
      {' '}
      <Typography style={{ paddingBottom: '25px', textAlign: 'center' }}>
        Create Retest Exam
      </Typography>
      <Divider></Divider>
      <Grid style={{ paddingTop: '25px' }} container spacing={3}>
        <Grid item xs={12} sm={6}>
          <KenSelectWrap
            label="Term Name"
            options={termOptions}
            value={selectedTerm}
            // defaultValue={() => {
            //   return termOptions[0].value;
            // }}
            dropdownColor="#FFFFFF"
            onChange={handleTermChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenSelectWrap
            label="Course Name || Exam Name"
            options={CourseOptions}
            value={selectedCourse}
            // defaultValue={() => {
            //   return courseOptions[0].value;
            // }}
            dropdownColor="#FFFFFF"
            onChange={handleCourseChange}
            required
          />
        </Grid>{' '}
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'examDate'}
            label="Exam Date"
            value={examDate}
            type="date"
            required={true}
            onChange={manageExamDate}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'startTime'}
            label="Start Time"
            value={startTime}
            type="time"
            required={true}
            // defaultValue={startData}
            onChange={manageExamTime}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenSelectWrap
            label="Duration"
            options={durationOptions}
            value={selectDuration}
            // defaultValue={() => {
            //   return durationOptions[0].value;
            // }}
            // dropdownColor="#FFFFFF"
            onChange={handleDurationChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenSelectWrap
            label="Exam Type"
            options={examTypeOptions}
            value={selectedexamType}
            dropdownColor="#FFFFFF"
            onChange={handleExamTypeChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenSelectWrap
            label="Batch"
            options={batchOptions}
            value={selectedBatch}
            dropdownColor="#FFFFFF"
            onChange={handleBatchChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenSelectWrap
            label="Exam Cycle"
            options={examCycleOptions}
            value={selectedexamCycle}
            dropdownColor="#FFFFFF"
            onChange={handleExamCycleChange}
            required
          />
        </Grid>{' '}
        <Grid item xs={12} sm={6}>
          <KenSelectWrap
            label="Exam Mode"
            options={examModeOptions}
            value={selectExamMode}
            // defaultValue={() => {
            //   return examTypeOptions[0].value;
            // }}
            dropdownColor="#FFFFFF"
            onChange={handleExamModeChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}></Grid>
        <Grid item xs={12} sm={6}>
          {' '}
          <KenButton
            color="primary"
            variant="secondary"
            onClick={() => createExam()}
            style={{ marginLeft: 'auto', display: 'flex' }}
          >
            Submit
          </KenButton>
        </Grid>{' '}
        <Grid item xs={12} sm={6}>
          {' '}
          <KenButton
            color="primary"
            variant="secondary"
            onClick={() => closeBtn()}
          >
            Cancel
          </KenButton>
        </Grid>
      </Grid>
    </div>
  );
};

export default RetestExam;
